import React from "react";
import { TableCellCaseAppealIcon } from "../../../../data-model/tableCells";
import AppealCol from "../../../../svg/appeal-col";
import TickWithGreenOutline from "../../../../svg/tickWithGreenOutline";

interface CaseAppealIconCellProps {
  value: TableCellCaseAppealIcon | null | undefined;
}

/**
 * Renders the Case Appeal column icon: outlined green check or ellipsis badge.
 *
 * @param value - Cell value with the icon variant to display
 * @return Icon markup or an empty cell when no variant is set
 */
export const CaseAppealIconCell: React.FC<CaseAppealIconCellProps> = ({
  value,
}) => {
  if (!value?.variant) {
    return <div className="flex h-full w-full items-center" />;
  }

  return (
    <div className="flex h-full w-full items-center">
      {value.variant === "approved" ? (
        <TickWithGreenOutline />
      ) : (
        <AppealCol />
      )}
    </div>
  );
};

export default CaseAppealIconCell;
